import { render, staticRenderFns } from "./MaterialCategorySelector.vue?vue&type=template&id=2db7e990&scoped=true&lang=pug&"
import script from "./MaterialCategorySelector.vue?vue&type=script&lang=js&"
export * from "./MaterialCategorySelector.vue?vue&type=script&lang=js&"
import style0 from "./MaterialCategorySelector.vue?vue&type=style&index=0&id=2db7e990&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db7e990",
  null
  
)

export default component.exports